// extracted by mini-css-extract-plugin
export default {"alignRight":"_c384bdb4","currency":"_5a0b1d1e","tooltipBody":"_23b2d05c","strong":"_41bd478a"};